import { isBefore, subWeeks } from 'date-fns'
import { datadogLogs } from '@datadog/browser-logs'

import { PersistentState } from 'directFlow/state/persistentState/type'

const quoteRegex = new RegExp(
  /\b[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}_DIRECT\b/,
)

export const isOldQuoteKey = (localStorageKey: string, currentQuoteId: string): boolean =>
  localStorageKey !== `${currentQuoteId}_DIRECT` && Boolean(localStorageKey.match(quoteRegex))

export const isQuoteOlderThanTwoWeeks = (quote: PersistentState): boolean => {
  const twoWeeksAgo = subWeeks(new Date(), 2)
  const quoteDate = new Date(quote.meta.createdAt)

  return isBefore(quoteDate, twoWeeksAgo)
}

export const removePreviousPartialQuotes = (newQuoteId: string): void => {
  const oldPartialQuotes = Object.entries(localStorage)
    .filter((quote) => isOldQuoteKey(quote[0], newQuoteId))
    .filter((quote) => isQuoteOlderThanTwoWeeks(JSON.parse(quote[1])))
    .map((item) => item[0])

  if (oldPartialQuotes.length === 0) {
    return
  }
  oldPartialQuotes.forEach((key) => {
    localStorage.removeItem(key)
  })

  datadogLogs.logger.log(
    `Removing ${oldPartialQuotes.length} old quotes for quoteId: ${newQuoteId}`,
  )
}
